import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import 'nprogress/nprogress.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { QueryProvider } from 'src/react-query/QueryProvider';
import { ErrorBoundary } from 'src/common/ErrorBoundary';
import { reportError } from 'src/common/services/posthogService';
import { MaintenanceGuard, ApiHealthGuard } from './guards';

const StatusMaintenance = lazy(
  () => import('./content/pages/Status/StatusMaintenance')
);

/**
 * Status component that renders while in suspense / maintenance mode.
 */
const SuspenseFallback = () => <StatusMaintenance />;

/**
 * AppContainer component to render the main application wrapped in providers and guards.
 */
const AppContainer = () => {
  return (
    <ErrorBoundary
      FallbackComponent={SuspenseFallback}
      onError={(error, info) =>
        reportError(error, { boundary: 'app-root', componentStack: info?.componentStack })
      }
    >
      <Suspense fallback={<SuspenseFallback />}>
        <Provider store={store}>
          <QueryProvider>
            <HelmetProvider>
              <SidebarProvider>
                <BrowserRouter>
                  <MaintenanceGuard>
                    <ApiHealthGuard>
                      <App />
                      {/* <p>jahsg</p> */}
                    </ApiHealthGuard>
                  </MaintenanceGuard>
                </BrowserRouter>
              </SidebarProvider>
            </HelmetProvider>
          </QueryProvider>
        </Provider>
      </Suspense>
    </ErrorBoundary>
  );
};

// Use createRoot for concurrent rendering in React 18
const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<AppContainer />);

serviceWorker.unregister();

